import nftclub from './nftClub';
import alsafina from './alsafina';
import ipl from './ipl'
import invest from './investalog'
import optics from './optics'

const projects = [nftclub, alsafina, ipl, invest, optics];

export default projects;
